/**
 * Builds the crm_schema fragment Admin sends when changing Salesforce
 * integration type. Kept pure so Native→Canvas / Canvas→Native status writes
 * can be unit-tested without the full CRMSelector store harness.
 */
export type BuildCanvasMigrationSchemaPatchArgs = {
  newPlatformSync: boolean
  switchingNativeToCanvas: boolean
  switchingCanvasToNative: boolean
  customerNeedsMigration: boolean
}

export type CanvasMigrationSchemaPatch = {
  new_platform_sync: boolean
  canvas_migration_status?: 'pending' | null
}

export const buildCanvasMigrationSchemaPatch = ({
  newPlatformSync,
  switchingNativeToCanvas,
  switchingCanvasToNative,
  customerNeedsMigration,
}: BuildCanvasMigrationSchemaPatchArgs): CanvasMigrationSchemaPatch => {
  const schemaPatch: CanvasMigrationSchemaPatch = {
    new_platform_sync: newPlatformSync,
  }

  if (switchingNativeToCanvas && customerNeedsMigration) {
    schemaPatch.canvas_migration_status = 'pending'
  } else if (switchingCanvasToNative) {
    schemaPatch.canvas_migration_status = null
  }

  return schemaPatch
}
